export default "__VITE_ASSET__oV6PeHhO__"